import { months } from "global/globalState";

export const dateFormat = (timestamp: string) => {
    const date = timestamp ? new Date(timestamp) : new Date();

    const formattedDate = `${months[date.getUTCMonth()]} ${date.getUTCDate()}/${date.getUTCFullYear()}`;

    return formattedDate;
}